import { render, staticRenderFns } from "./BasicCashupForm.vue?vue&type=template&id=bbd684d6&scoped=true"
import script from "./BasicCashupForm.vue?vue&type=script&lang=js"
export * from "./BasicCashupForm.vue?vue&type=script&lang=js"
import style0 from "./BasicCashupForm.vue?vue&type=style&index=0&id=bbd684d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd684d6",
  null
  
)

export default component.exports